/**
 * Content Studio · Preparación del motor de contenido.
 * Sin generación real (Fase 2). Sólo planificación visual.
 */
import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import {
  Sparkle, InstagramLogo, TiktokLogo, LinkedinLogo, FacebookLogo,
  ArticleNyTimes, Envelope, Lock,
} from "@phosphor-icons/react";

const ICONS = {
  instagram: InstagramLogo, tiktok: TiktokLogo, linkedin: LinkedinLogo,
  facebook: FacebookLogo, blog: ArticleNyTimes, newsletter: Envelope,
};

export default function ContentStudio() {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/founder-os/content/channels")
      .then(({ data }) => setChannels(data.channels || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 lg:p-8 space-y-5" data-testid="founder-content">
      <header>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--ag-gold)] font-semibold flex items-center gap-1.5">
          <Sparkle size={11} weight="fill" /> Content Studio
        </div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tighter mt-2">
          Motor de contenido · planificación
        </h1>
        <p className="text-xs text-[var(--ag-text-dim)] mt-1">
          Canales y formatos preparados · generación real con LLM en Fase 2 (Agent AG-04 Content Agent)
        </p>
      </header>

      {loading ? (
        <div className="text-xs text-[var(--ag-text-dim)]">Cargando…</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="content-channels">
          {channels.map((c) => {
            const Icon = ICONS[c.code] || Sparkle;
            return (
              <div key={c.code}
                   className="rounded-lg border border-[var(--ag-border)] bg-[var(--ag-surface)] p-4 opacity-90"
                   data-testid={`channel-${c.code}`}>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-[var(--ag-gold)]/10 grid place-items-center text-[var(--ag-gold)] shrink-0">
                    <Icon size={18} weight="duotone" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display text-base font-bold tracking-tight">{c.label}</div>
                    <div className="flex items-center gap-1 text-[10px] text-[var(--ag-text-muted)] mt-1">
                      <Lock size={9} /> {c.status}
                    </div>
                  </div>
                </div>
                <div className="mt-3 pt-3 border-t border-[var(--ag-border)]">
                  <div className="text-[9px] uppercase tracking-wider text-[var(--ag-text-muted)] mb-1.5">
                    Formatos planificados
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {c.post_types.map((pt) => (
                      <span key={pt}
                            className="text-[10px] text-[var(--ag-text-dim)] bg-[var(--ag-midnight)]/40 px-1.5 py-0.5 rounded">
                        {pt}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="rounded-lg border border-[var(--ag-gold)]/30 bg-[var(--ag-gold)]/5 p-4 text-xs">
        <div className="text-[10px] uppercase tracking-wider text-[var(--ag-gold)] font-semibold mb-2">
          Próximos pasos para activar este módulo
        </div>
        <ul className="space-y-1.5 text-[var(--ag-text-dim)]">
          <li>1. Activar agente <strong>AG-04 Content Agent</strong> en Agent Center (cambiar status: planned → active).</li>
          <li>2. Configurar API keys de cada plataforma (Instagram Graph API, TikTok Content Posting API, LinkedIn Marketing).</li>
          <li>3. Definir calendario editorial basado en la Taxonomía v1.1 (30 macros × N ciudades).</li>
          <li>4. Conectar con Knowledge Base para grounding (taxonomía + auditorías + branding).</li>
          <li>5. Implementar aprobación humana antes de publicación (workflow draft → review → publish).</li>
        </ul>
      </div>
    </div>
  );
}
